export default __webpack_public_path__ + "static/media/SG-LightBlue-0006.6fe48d5f.png";